import $ from 'jquery'
// import _ from 'lodash';
import React from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import ProductsFilterItem from './ProductsFilterItem'
// import PropTypes from 'prop-types';
// import { Route } from 'react-router-dom';
// import { breakpoints } from 'dom/_site';

class ProductsFiltersTop extends React.Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    $(window).triggerHandler('resize.sidebar')
  }
  render() {
    // const { filters, requestFilteredProductsList, clearFilters, toggleFilter } = this.props;
    const { filters } = this.props

    if (filters) {
      return (
        <React.Fragment>
          {typeof filters.Type != 'undefined' && (
            <ProductsFilterItem filter={filters.Type} filterKey="Type" filterTitle="Product Type" {...this.props} />
          )}
          {typeof filters.Varietal != 'undefined' && (
            <ProductsFilterItem filter={filters.Varietal} filterKey="Varietal" filterTitle="Varietal" {...this.props} />
          )}
        </React.Fragment>
      )
    }
  }
}

// default props
ProductsFiltersTop.defaultProps = {}
// validate props
ProductsFiltersTop.propTypes = {}

export default ProductsFiltersTop
